// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__29JiF","cell":"ColumnAccessor_cell__25VHP","firstCellAccent":"ColumnAccessor_firstCellAccent__HxWTC"};